import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DollarSign, TrendingUp, TrendingDown, PieChart } from 'lucide-react';
import { formatCurrency } from '@/lib/utils';

const accountingSummary = [
  { label: 'Total Income', value: 125000, change: '+12%', trend: 'up' },
  { label: 'Total Expenses', value: 45000, change: '+5%', trend: 'up' },
  { label: 'Net Income', value: 80000, change: '+18%', trend: 'up' },
  { label: 'Outstanding Receivables', value: 12500, change: '-8%', trend: 'down' },
];

export default function AccountingPage() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Accounting Overview</h1>
        <p className="mt-2 text-gray-600">
          Comprehensive financial management for your property portfolio
        </p>
      </div>

      {/* Summary Cards */}
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {accountingSummary.map((item) => (
          <Card key={item.label}>
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600">{item.label}</p>
                  <p className="mt-2 text-2xl font-bold text-gray-900">
                    {formatCurrency(item.value)}
                  </p>
                  <div className="mt-2 flex items-center gap-1">
                    {item.trend === 'up' ? (
                      <TrendingUp className="h-4 w-4 text-green-600" />
                    ) : (
                      <TrendingDown className="h-4 w-4 text-red-600" />
                    )}
                    <span
                      className={`text-sm font-medium ${
                        item.trend === 'up' ? 'text-green-600' : 'text-red-600'
                      }`}
                    >
                      {item.change}
                    </span>
                  </div>
                </div>
                <div className="rounded-full bg-primary-50 p-3">
                  <DollarSign className="h-6 w-6 text-primary-600" />
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Quick Actions */}
      <Card>
        <CardHeader>
          <CardTitle>Quick Actions</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            <button className="flex flex-col items-center gap-2 rounded-lg border-2 border-dashed border-gray-300 p-6 transition-colors hover:border-primary-500 hover:bg-primary-50">
              <PieChart className="h-8 w-8 text-gray-400" />
              <span className="text-sm font-medium text-gray-700">Record Transaction</span>
            </button>
            <button className="flex flex-col items-center gap-2 rounded-lg border-2 border-dashed border-gray-300 p-6 transition-colors hover:border-primary-500 hover:bg-primary-50">
              <PieChart className="h-8 w-8 text-gray-400" />
              <span className="text-sm font-medium text-gray-700">Generate Report</span>
            </button>
            <button className="flex flex-col items-center gap-2 rounded-lg border-2 border-dashed border-gray-300 p-6 transition-colors hover:border-primary-500 hover:bg-primary-50">
              <PieChart className="h-8 w-8 text-gray-400" />
              <span className="text-sm font-medium text-gray-700">Reconcile Bank</span>
            </button>
            <button className="flex flex-col items-center gap-2 rounded-lg border-2 border-dashed border-gray-300 p-6 transition-colors hover:border-primary-500 hover:bg-primary-50">
              <PieChart className="h-8 w-8 text-gray-400" />
              <span className="text-sm font-medium text-gray-700">Pay Bills</span>
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
